module.exports = __webpack_public_path__ + "static/media/image.91c3b226.png";